import {
    PbxHttpClient
} from "@/services/httpclient";

const state = {
    allExtension: []
};

const getters = {};

const mutations = {
    SET_ALL_EXTENSION(state, payload) {
        state.allExtension = payload;
    }
};

const actions = {
    async SHOW_EXTENSION({
        commit
    }, payload) {
        try {
            // get(`/showextension?dateIni=${payload.ini}&dateFin=${payload.ini}`)
            const response = await PbxHttpClient.get(`/showextension?dateIni=${payload[0]}&dateFin=${payload[1]}`);
            commit("SET_ALL_EXTENSION", response.data.data);
            return response;
        } catch (error) {
            return Promise.reject(error);
        }
    }

    // async GET_ACTIVE_CALLS({ commit }) {
    //     try {
    //         const response = await PbxHttpClient.get("/clients/activated");
    //         commit("SET_ALL_CALLS", response.data);
    //         return response;
    //     } catch (error) {
    //         return Promise.reject(error);
    //     }
    // }
};

// Exportar llamadas
export const callsInfo = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
